import { Box, Typography, useTheme } from '@mui/material';
import { BlurredStack } from 'modules/common/components/BlurredStack';

import { InfoIcon } from 'modules/common/icons';

export const BTC_LBTC_RATIO_TEXT = '1 BTC = 1 LBTC';
export const STAKE_FEE = '0.00';

export function DepositDisclaimer(): JSX.Element {
  const theme = useTheme();

  return (
    <BlurredStack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      mt={3}
      gap={1}
      sx={{
        padding: 2,
        borderRadius: 1.2,
      }}
    >
      <Box
        sx={{
          height: 20,
        }}
      >
        <InfoIcon width={20} height={20} color={theme.palette.text.secondary} />
      </Box>
      <Typography
        variant="body1"
        color="textSecondary"
        sx={{ width: '100%', pr: 0.5 }}
      >
        This vault is not accepting further deposits.
      </Typography>
    </BlurredStack>
  );
}
